"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _constants = require("../../utils/constants");
var _LottieAnimate = _interopRequireDefault(require("../LottieAnimate"));
var ThreadListZero = function ThreadListZero() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useTheme = (0, _styles.useTheme)(),
    palette = _useTheme.palette;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-full flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_LottieAnimate["default"], {
    className: "w-40",
    path: palette.type === _constants.themeMode.DARK ? t('inbox-zero-dark.json') : t('inbox-zero.json')
  }));
};
var _default = exports["default"] = ThreadListZero;
//# sourceMappingURL=ThreadListZero.js.map